import { themeGet } from '@styled-system/theme-get';
import styled, { css } from 'styled-components';
import { Box, getPaletteColor } from 'pcln-design-system';
const Cell = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Cell",
  componentId: "sc-jf0yy1-0"
})(["&&&{vertical-align:top;line-height:1.8;text-align:center;cursor:pointer;color:", ";outline-offset:-2px;border-radius:", ";display:", ";align-items:center;justify-content:center;", "}"], getPaletteColor('border.base'), ({
  roundedCorners,
  isStart,
  isEnd,
  grouped,
  isCurrentHoverDate,
  showHoveredDates
}) => {
  if (roundedCorners) {
    const radii = themeGet('borderRadii.lg');
    switch (true) {
      case !showHoveredDates:
        return css(["", ""], radii);
      case isStart:
        return css(["", " 0 0 ", ""], radii, radii);
      case isEnd:
        return css(["0 ", " ", " 0"], radii, radii);
      case grouped || isCurrentHoverDate:
        return '0';
      default:
        return css(["", ""], radii);
    }
  } else {
    return '0';
  }
}, ({
  roundedCorners
}) => roundedCorners ? 'flex' : 'inline-block', props => {
  if (!props.valid) {
    return `
          cursor: default;
        `;
  }
  // This block is for arrow-key navigation, denotes current 'hovered' date (i.e. focused via keys)
  if (props.isCurrentHoverDate && !props.selected) {
    return `
          color: ${getPaletteColor('text.dark')(props)};
          ${!props.use2024DesignSeti && `outline: 1px solid ${getPaletteColor('primary.base')(props)};`}

          &:hover {
            background: ${props.isTouch ? 'transparent' : getPaletteColor('primary.light')(props)};
          }
        `;
  }
  if (!props.grouped && !props.selected) {
    return `
          color: ${getPaletteColor('text.dark')(props)};

          &:focus {
            outline: 1px solid ${getPaletteColor('primary.base')(props)};
          }
          &:hover {
            background: ${props.isTouch ? 'transparent' : getPaletteColor('primary.light')(props)};
            ${!props.use2024DesignSeti && `outline: 1px solid ${getPaletteColor('primary.base')(props)};`}
          }
        `;
  }
  if (props.grouped && !props.selected) {
    return `
          color: ${getPaletteColor(props.use2024DesignSeti ? 'text.lightest' : 'text.dark')(props)};
          background: ${getPaletteColor(props.use2024DesignSeti ? 'primary.dark' : 'primary.light')(props)};
        `;
  }
  if (props.selected) {
    return `
          color: ${getPaletteColor('text.lightest')(props)};
          background: ${getPaletteColor('primary.base')(props)};
          border-color: ${getPaletteColor('primary.base')(props)};
          outline: 1px dashed ${getPaletteColor('primary.base')(props)};

          &:focus {
            outline: 2px solid ${getPaletteColor('primary.base')(props)};
            color: ${getPaletteColor('text.base')(props)};
            background: ${getPaletteColor('primary.light')(props)};
          }
        `;
  }
});
export default Cell;